import { formatText } from "../pushNotificationMessage";

const messages = async ({ actionType, notifyContent }) => {

    const message = {
        newEnquiry: {
            title: `New Enquiry`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        declined: {
            title: `Declined`,
            message: `${formatText(notifyContent['userName'])}: Booking is Declined`
        },
        approved: {
            title: `Approved`,
            message: `${formatText(notifyContent['userName'])}: Booking is Approved`
        },
        newMessage: {
            title: `New Message`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelReservation: {
            title: `Booking is Cancelled`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        cancelled: {
            title: `Booking Cancelled`,
            message: `${formatText(notifyContent['userName'])}: Booking request has been cancelled`
        },
        newBooking: {
            title: `New Booking`,
            message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
        },
        preApprove: {
            title: `New Booking`,
            message: `${formatText(notifyContent['userName'])}: Your request is pre-approved`
        },
        listApproved: {
            title: `Admin has verified your listing`,
            message: `${formatText(notifyContent['userName'])} : Admin has verified your listing ${notifyContent['listTitle']} . Please publish your listing to get reservations.`
        },
        listDeclined: {
            title: `Admin has declined your listing`,
            message: `${formatText(notifyContent['userName'])} : Admin has declined your listing request for the ${notifyContent['listTitle']} due to the reason of ${notifyContent['reason']}. Kindly update the listing information and submit for the list approval.`
        },
        noHostPayout: {
            title: `Payout details Missing`,
            message: `${formatText(notifyContent['userName'])}:Update! Please update your payout information to receive the booking payouts`
        },
        approvedDocument: {
            title: `Document Approved!`,
            message: `Your document has been successfully approved.`
        },
        rejectDocument: {
            title: `Document Rejected!`,
            message: `Your submitted document has been rejected by the admin. Kindly contact the admin for more information.`
        }
    }

    return message[actionType] ? message[actionType] : { title: '', message: '' }
}
export default messages;